export enum WorkListItemType {
    patientTask = 'patientTask',
    processTask = 'processTask',
    request = 'request',
}
